module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-R-IGZO-1.f0238503.jpg";